import { MagicSearchEntityType, MagicSearchResponseDTO } from '@iota/inh-core-v1-management-client';

export type SearchState = { status: 'idle' } | { status: 'loading' } | { status: 'error' } | { status: 'ok'; res: MagicSearchResponseDTO };

export interface MagicSearchActiveUntil {
    label: string;
    date: string;
}

export interface MagicSearchRow {
    key: string;
    icon: string;
    label: string;
    additionalData?: string[];
    badge?: string;
    activeUntil?: MagicSearchActiveUntil;
    link: string;
}

export type MagicSearchCategoryType = 'EMPLOYEE' | 'CUSTOMER' | 'SOLUTION_PARTNER' | 'PRODUCT' | 'CASE_MANAGEMENT';

export type MagicSearchGroupType = 'PERFECT' | MagicSearchCategoryType;

export interface MagicSearchCategory {
    type: MagicSearchCategoryType;
    entityTypes: MagicSearchEntityType[];
}

export interface MagicSearchGroup {
    type: MagicSearchGroupType;
    labelId: string;
    rows: MagicSearchRow[];
}

export interface IndexedMagicSearchRow extends MagicSearchRow {
    index: number;
}

export interface IndexedMagicSearchGroup {
    type: MagicSearchGroupType;
    labelId: string;
    rows: IndexedMagicSearchRow[];
}

export const ENTITY_ICON: Record<MagicSearchEntityType, string> = {
    EMPLOYEE: 'users',
    CUSTOMER: 'building-office',
    SOLUTION_PARTNER: 'building-storefront',
    PRODUCT: 'cube',
    SUBMISSION: 'document-arrow-down',
    CASE: 'document-check',
    INSURANCE_NUMBER: 'square-2-stack'
};

export const CATEGORY_ORDER: MagicSearchCategory[] = [
    { type: 'EMPLOYEE', entityTypes: ['EMPLOYEE'] },
    { type: 'CUSTOMER', entityTypes: ['CUSTOMER'] },
    { type: 'SOLUTION_PARTNER', entityTypes: ['SOLUTION_PARTNER'] },
    { type: 'PRODUCT', entityTypes: ['PRODUCT'] },
    { type: 'CASE_MANAGEMENT', entityTypes: ['SUBMISSION', 'CASE', 'INSURANCE_NUMBER'] }
];

export const CATEGORY_LABEL: Record<MagicSearchGroupType, string> = {
    PERFECT: $localize`Best match`,
    EMPLOYEE: $localize`Employees`,
    CUSTOMER: $localize`Customers`,
    SOLUTION_PARTNER: $localize`Solution Partners`,
    PRODUCT: $localize`Products`,
    CASE_MANAGEMENT: $localize`Case Management`
};

/** End-date badge term per entity type; types without an entry fall back to DEFAULT_ACTIVE_UNTIL_LABEL. */
export const ACTIVE_UNTIL_LABEL: Partial<Record<MagicSearchEntityType, string>> = {
    EMPLOYEE: $localize`License end`,
    CUSTOMER: $localize`Deactivation date`,
    SOLUTION_PARTNER: $localize`Deactivation date`,
    PRODUCT: $localize`Discontinued`
};

export const DEFAULT_ACTIVE_UNTIL_LABEL = $localize`Active until`;

export const LABEL_SEPARATOR = ' · ';
